export default __webpack_public_path__ + "static/media/RHSLogo-white.62552484.png";